import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useConfig } from 'hooks';
import {
	removeTargetedOffers,
	removeTargetedOfferSelected,
	loadTargetedOffers,
	retryTargetedOffersSignIn,
	fetchTargetedOffers,
	removePromoCode,
	closeTargetedOffersPill,
	updateTargetedOfferPill,
	selectTargetedOffer,
	applyTargetedOffer,
	refreshAppliedTargetOffer,
} from './functions';
import { useFeatureFlags } from '../../hooks/LaunchDarkly/useFeatureFlags';

export const TargetedOffersContext = React.createContext({});

const TargetedOffersContextProvider = ({ children, router, apolloClient, initialState }) => {
	const config = useConfig();
	const {
		updateState,
		targetedOffers,
		targetedOffersLoading,
		targetedOffersLoaded,
		errorTargetedOffers,
		removeFromQualifiersSelecting,
		applyFilters,
		globalization,
		targetedOffersQuery,
		addToQualifiersSelecting,
		fetchAndUpdateFacetOptions,
		setPromotionSelected,
		promotions,
		targetedOfferApplied,
		targetedOfferSelected,
	} = useContext(CruiseSearchContext);
	const flags = useFeatureFlags();

	const { query = {} } = router || {};

	const state = {};

	const [contextState, setContextState] = useState(state);

	useEffect(() => {
		loadTargetedOffers({
			updateState,
			initialState,
			apolloClient,
			globalization,
			toogles: flags,
			errorTargetedOffers,
			targetedOffers,
			targetedOffersLoading,
			targetedOffersLoaded,
			query,
			removeFromQualifiersSelecting,
			applyFilters,
			config,
		});
		setContextState({
			...contextState,
			removeTargetedOfferSelected: () => {
				removeTargetedOfferSelected({ updateState });
			},
			removeTargetedOffers: () => {
				removeTargetedOffers({ updateState });
			},
			fetchTargetedOffers: (inputData) => {
				fetchTargetedOffers({
					updateState,
					inputData,
					globalization,
					initialState,
					apolloClient,
					query,
					toogles: flags,
					targetedOffersLoading,
					removeFromQualifiersSelecting,
					applyFilters,
					config,
				});
			},
			retryTargetedOffersSignIn: () => {
				retryTargetedOffersSignIn({
					updateState,
					initialState,
					apolloClient,
					globalization,
					toogles: flags,
					errorTargetedOffers,
					targetedOffers,
					targetedOffersLoading,
					targetedOffersLoaded,
					query,
					removeFromQualifiersSelecting,
					applyFilters,
					targetedOffersQuery,
				});
			},
			removePromoCode: () => {
				removePromoCode({ updateState });
			},
			closeTargetedOffersPill: () => {
				closeTargetedOffersPill({ updateState });
			},
			updateTargetedOfferPill: (targetedOffersPillShow) => {
				updateTargetedOfferPill({ updateState, targetedOffersPillShow });
			},
			selectTargetedOffer: (offer) => {
				selectTargetedOffer({ offer, updateState, setPromotionSelected, addToQualifiersSelecting, fetchAndUpdateFacetOptions });
			},
			applyTargetedOffer: (offer) => {
				applyTargetedOffer({ offer, updateState, addToQualifiersSelecting, fetchAndUpdateFacetOptions, applyFilters });
			},
			refreshAppliedTargetOffer: (callback) => {
				refreshAppliedTargetOffer({ callback, updateState, applyFilters, promotions, targetedOfferApplied, targetedOfferSelected });
			},
		});
	}, [
		updateState,
		initialState,
		apolloClient,
		globalization,
		flags,
		errorTargetedOffers,
		targetedOffers,
		targetedOffersLoading,
		targetedOffersLoaded,
		query,
		removeFromQualifiersSelecting,
		applyFilters,
		promotions,
	]);

	return <TargetedOffersContext.Provider value={contextState}>{children}</TargetedOffersContext.Provider>;
};

TargetedOffersContextProvider.propTypes = {
	children: PropTypes.node,
	router: PropTypes.any,
	apolloClient: PropTypes.any,
	initialState: PropTypes.any,
};

export default withRouter(TargetedOffersContextProvider);
